<template>
  <div class="catalogDetail">
    <div class="Left">
      <div class="title">
        <div class="box">
          <div class="left">
            <img :src="list.cover" alt="" />
          </div>
          <div class="right">
            <h2 :title="list.title">{{ list.title }}</h2>
            <p>{{ list.teacher }}</p>
          </div>
        </div>
      </div>
      <div class="menu">
        <div class="log">
          <Menu :munelist="munelist" @getdetail="getdetail"></Menu>
        </div>
      </div>
    </div>
    <div class="Right">
      <isvideo
        v-if="info.type == 0"
        :resourceUrl="resourceUrl"
        :title="title"
        :catId="catId"
        :menuId="menuId"
        @gocourse="gocourse"
        :isFinished="isFinished"
        :joined="joined"
        :isFree="isFree"
        :studyTime="studyTime"
        :chapterId="chapterId"
      >
      </isvideo>
      <ispdf
        v-else-if="info.type == 1"
        :resourceUrl="resourceUrl"
        :title="title"
        :catId="catId"
        :menuId="menuId"
        :isFree="isFree"
        @gocourse="gocourse"
        :chapterId="chapterId"
      >
      </ispdf>
      <istest
        v-else-if="info.type == 2"
        :title="title"
        :testInfo="testInfo"
        :catId="catId"
        :menuId="menuId"
        @totest="totest"
        @seetest="seetest"
        :paperId="paperId"
        @gocourse="gocourse"
        :isFinished="isFinished"
        :joined="joined"
        :chapterId="chapterId"
      ></istest>
      <isexam
        v-else-if="info.type == 3"
        :title="title"
        :testInfo="testInfo"
        @totheoryexam="totheoryexam"
        @seetheoryexam="seetheoryexam"
        @toprexam="toprexam"
        :catId="catId"
        :menuId="menuId"
        :paperId="paperId"
        @gocourse="gocourse"
        :isFinished="isFinished"
        :examType="examType"
        :operationQuestionFinished="operationQuestionFinished"
        :chapterId="chapterId"
      ></isexam>
      <a-empty v-else description="加载中" />
    </div>
  </div>
</template>

<script>
import entry from "../units/entryDetry.js";
import Menu from "@/components/common/Menu";
import ispdf from "@/components/common/ispdf";
import isvideo from "@/components/common/isvideo";
import istest from "@/components/common/istest";
import isexam from "@/components/common/isexam";
import {
  getcourseDetailApi,
  getcatalogApi,
  getupdateStatusApi,
} from "@/request/api";

export default {
  name: "catalogDetail",
  components: { Menu, ispdf, isvideo, istest, isexam },
  data() {
    return {
      catId: null,
      menuId: "",
      list: [],
      munelist: [],
      info: "",
      type: "",
      title: "",
      testInfo: "",
      resourceUrl: "",
      paperId: "",
      isFinished: "",
      examType: "",
      operationQuestionFinished: "",
      operationQuestionAccess: "",
      joined: "",
      examAccess: "",
      chapterId: "",
      studyTime: "",
      isFree: "",
    };
  },
  sockets: {
    connect() {
      console.log("链接成功");
      if (this.isLogin == 0) {
        // console.log("用户id",localStorage.getItem('userId'))
        this.$socket.emit("login", {
          role: this.role,
          userId: localStorage.getItem("userId"),
        });
        this.$socket.emit("studyStart", {
          courseId: this.catId,
          taskId: this.menuId,
        });
      }
    },
    studyStart() {
      console.log("进入任务");
    },
    studyEnd() {
      console.log("离开任务");
    },
    // studyStart 进入任务后发送 courseId taskId
    // studyEnd 离开任务后发送 couseId taskId
  },
  computed: {
    taskId() {
      return this.$store.state.taskId;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    role() {
      return this.$store.state.role;
    },
    userId() {
      return this.$store.state.userId;
    },
  },
  watch: {
    isLogin: function () {
      this.init();
    },
    taskId: function (val) {
      this.menuId = val;
      this.init();
    },
    role: function () {},
    userId: function (val) {},
  },
  created() {
    if (this.$route.query.paperId) {
      this.paperId = JSON.parse(this.$Base64.decode(this.$route.query.paperId));
    }
    if (this.$route.query.joined) {
      this.joined = JSON.parse(this.$Base64.decode(this.$route.query.joined));
    }
    if (this.$route.query.id) {
      this.catId = JSON.parse(this.$Base64.decode(this.$route.query.id));
    }
    if (this.$route.query.menuId) {
      this.menuId = JSON.parse(this.$Base64.decode(this.$route.query.menuId));
    }
    // console.log("132:",this.$route.query.resourceUrl)
    if (this.$route.query.resourceUrl) {
      this.resourceUrl = this.$Base64.decode(this.$route.query.resourceUrl);
    }
    if (this.$route.query.isFree) {
      this.isFree = this.$Base64.decode(this.$route.query.isFree);
    }

    this.init();
  },
  methods: {
    init() {
      this.getToken(getcourseDetailApi, { courseId: this.catId }, (res) => {
        this.list = res.data;
        this.examAccess = res.data.examAccess;
        this.munelist = res.data.chapters;
        this.joined = res.data.joined;
      });
      getcatalogApi({ taskId: this.menuId }).then((res) => {
        if (res.code == 200) {
          this.info = res.data;
          this.resourceUrl = res.data.resourceUrl;
          this.isFinished = res.data.isFinished;
          this.operationQuestionFinished = res.data.operationQuestionFinished;
          this.operationQuestionAccess = res.data.operationQuestionAccess;
          this.joined = res.data.joined;
          this.testInfo = res.data.testInfo;
          this.examType = res.data.examType;
          this.title = res.data.title;
          this.studyTime = res.data.studyTime;
          // console.log(this.examType)
        } else {
          this.$message.error("当前试看权限已取消，返回上一页");
          this.$router.go(-1); //判断如果没有取到正确的字段，就自动返回到上一步
        }
      });
    },
    gocourse(id) {
      this.$router.push({
        path: "/catalog",
        query: { id: this.$Base64.encode(id) },
      });
      this.$socket.emit("studyEnd", {
        courseId: this.catId,
        taskId: this.menuId,
      });
    },
    getdetail(
      catalogId,
      id,
      type,
      title,
      testInfo,
      paperId,
      isFinished,
      isLogin,
      isFree,
      chapterId
    ) {
      this.$socket.emit("studyEnd", { courseId: this.catId, taskId: id });
      if (this.joined) {
        if (isFinished == false) {
          //判断是什么类型
          if (type == 0 || type == 2) {
            getcatalogApi({ taskId: id }).then((res) => {
              this.testInfo = testInfo;
              this.title = title;
              this.info = res.data;
              this.menuId = id;
              this.chapterId = chapterId;
              this.paperId = paperId;
              this.resourceUrl = res.data.resourceUrl;
              this.isFinished = res.data.isFinished;
              this.operationQuestionFinished =
                res.data.operationQuestionFinished;
              this.operationQuestionAccess = res.data.operationQuestionAccess;
              this.joined = res.data.joined;
              this.studyTime = res.data.studyTime;
            });
          } else if (type == 1) {
            this.getToken(
              getupdateStatusApi,
              { status: 1, courseId: this.catId, taskId: id },
              () => {
                this.$store.commit("getIds", {
                  chapterId: chapterId,
                  taskId: id,
                });
                getcatalogApi({ taskId: id }).then((res) => {
                  this.testInfo = testInfo;
                  this.title = title;
                  this.info = res.data;
                  this.menuId = id;
                  this.chapterId = chapterId;
                  this.paperId = paperId;
                  this.resourceUrl = res.data.resourceUrl;
                  this.isFinished = res.data.isFinished;
                  this.operationQuestionFinished =
                    res.data.operationQuestionFinished;
                  this.operationQuestionAccess =
                    res.data.operationQuestionAccess;
                  this.joined = res.data.joined;
                  this.studyTime = res.data.studyTime;
                });
              }
            );
          } else {
            if (this.examAccess == false) {
              this.$message.error("必须先完成所有任务，才能进行考试！");
            } else {
              getcatalogApi({ taskId: id }).then((res) => {
                this.testInfo = testInfo;
                this.title = title;
                this.info = res.data;
                this.menuId = id;
                this.chapterId = chapterId;
                this.paperId = paperId;
                this.resourceUrl = res.data.resourceUrl;
                this.isFinished = res.data.isFinished;
                this.operationQuestionFinished =
                  res.data.operationQuestionFinished;
                this.operationQuestionAccess = res.data.operationQuestionAccess;
                this.joined = res.data.joined;
                this.studyTime = res.data.studyTime;
              });
            }
          }
        } else {
          getcatalogApi({ taskId: id }).then((res) => {
            this.testInfo = testInfo;
            this.title = title;
            this.info = res.data;
            this.menuId = id;
            this.chapterId = chapterId;
            this.paperId = paperId;
            this.resourceUrl = res.data.resourceUrl;
            this.isFinished = res.data.isFinished;
            this.operationQuestionFinished = res.data.operationQuestionFinished;
            this.operationQuestionAccess = res.data.operationQuestionAccess;
            this.joined = res.data.joined;
            this.studyTime = res.data.studyTime;
          });
        }
      } else {
        // 没有加入此课程，判断是否有试看功能
        if (isFree == 1) {
          getcatalogApi({ taskId: id }).then((res) => {
            this.testInfo = testInfo;
            this.title = title;
            this.info = res.data;
            this.menuId = id;
            this.chapterId = chapterId;
            this.paperId = paperId;
            this.resourceUrl = res.data.resourceUrl;
            this.isFinished = res.data.isFinished;
            this.operationQuestionFinished = res.data.operationQuestionFinished;
            this.operationQuestionAccess = res.data.operationQuestionAccess;
            this.studyTime = res.data.studyTime;
          });
        } else {
          if (isLogin == 0) {
            this.$message.info("你还没有加入此课程，请先加入！");
          } else {
            this.$message.info("你还没登录");
          }
        }
      }
    },
    //去测试
    totest() {
      this.$confirm({
        title: "本测试仅支持答题一次，确定开始答题？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.$router.push({
            path: "/test",
            query: {
              paperId: this.$Base64.encode(this.paperId),
              id: this.$Base64.encode(this.catId),
              menuId: this.$Base64.encode(this.menuId),
              // title: this.$Base64.encode(this.title),
              // joined: this.$Base64.encode(this.joined),
              chapterId: this.$Base64.encode(this.chapterId),
              isFinished: this.$Base64.encode(this.isFinished),
            },
          });
          this.$socket.emit("studyStart", {
            courseId: this.catId,
            taskId: this.menuId,
          });
        },
        onCancel() {
          //  console.log('OK');
        },
      });
    },
    //查看测试成绩
    seetest(paperId, id, menuId) {
      // console.log(paperId);
      this.$router.push({
        path: "/test",
        query: {
          paperId: this.$Base64.encode(paperId),
          id: this.$Base64.encode(id),
          menuId: this.$Base64.encode(menuId),
          // title:this.$Base64.encode(title),
          // joined:this.$Base64.encode(this.joined),
          chapterId: this.$Base64.encode(this.chapterId),
          isFinished: this.$Base64.encode(this.isFinished),
        },
      });
      this.$socket.emit("studyStart", {
        courseId: this.catId,
        taskId: this.menuId,
      });
    },
    //确定考试
    examOk() {
      this.$router.push({
        path: "/theoryexam",
        query: {
          paperId: this.paperId,
          id: this.catId,
          menuId: this.menuId,
          isFinished: this.isFinished,
          chapterId: this.chapterId,
        },
      });
    },
    //点击考试
    totheoryexam() {
      this.$confirm({
        title: "本考试仅支持答题一次，确定开始答题？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.$router.push({
            path: "/theoryexam",
            query: {
              paperId: this.$Base64.encode(this.paperId),
              id: this.$Base64.encode(this.catId),
              menuId: this.$Base64.encode(this.menuId),
              isFinished: this.$Base64.encode(this.isFinished),
              chapterId: this.$Base64.encode(this.chapterId),
            },
          });
          this.$socket.emit("studyStart", {
            courseId: this.catId,
            taskId: this.menuId,
          });
        },
        onCancel() {
          //  console.log('OK');
        },
      });
    },
    //查看考试成绩
    seetheoryexam(paperId, id, menuId) {
      this.$router.push({
        path: "/theoryexam",
        query: {
          paperId: this.$Base64.encode(this.paperId),
          id: this.$Base64.encode(this.catId),
          menuId: this.$Base64.encode(this.menuId),
          isFinished: this.$Base64.encode(this.isFinished),
          chapterId: this.$Base64.encode(this.chapterId),
        },
      });
      this.$socket.emit("studyStart", {
        courseId: this.catId,
        taskId: this.menuId,
      });
    },
    //查看实操考试
    toprexam(paperId, id, menuId) {
      if (this.operationQuestionAccess) {
        this.$router.push({
          path: "/prexam",
          query: { paperId, id, menuId, chapterId: this.chapterId },
        });
        this.$socket.emit("studyStart", {
          courseId: this.catId,
          taskId: this.menuId,
        });
      } else {
        this.$message.info("你还没有通过理论考试");
      }
    },
    beforeRouteLeave(to, from, next) {
      this.$socket.emit("studyEnd", {
        courseId: this.catId,
        taskId: this.menuId,
      });
      next();
    },
  },
};
</script>

<style >
.catalogDetail .ant-menu-inline .ant-menu-item::after {
  border-right: 0px;
  background: #f0cd48;
}
.catalogDetail .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.catalogDetail
  .ant-menu-sub.ant-menu-inline
  > .ant-menu-submenu
  > .ant-menu-submenu-title {
  height: 45px;
  line-height: 45px;
  list-style-position: inside;
  list-style-type: disc;
  padding-left: 25px !important;
}
.catalogDetail .ant-menu-inline {
  background: #eee;
}
.catalogDetail .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  background: #fff;
  padding-left: 16px !important;
}
.catalogDetail .ant-menu-inline .ant-menu-submenu-title {
  margin-top: 0;
  font-size: 16px;
}
.catalogDetail .ant-menu-submenu > .ant-menu {
  background-color: #eee;
  border-radius: 4px;
}
.catalogDetail .ant-menu-inline .ant-menu-submenu {
  border-bottom: solid 1px #eff2f2;
  background: #fff;
  margin-bottom: 16px;
}
.ant-menu-inline {
  border-right: 1px solid #e8e8e8;
  background: #eee;
}
.catalogDetail .ant-menu-sub.ant-menu-inline > .ant-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #eee;
  font-size: 15px;
}
.sureModal .ant-modal-body {
  margin-top: 20px;
  padding: 0px;
  word-wrap: break-word;
}
.sureModal .ant-modal-body .box {
  margin: 0 auto;
  margin-top: 30px;
  font-size: 18px;
  margin-bottom: 30px;
  text-align: center;
}
/* .catalogDetail .ant-menu-sub.ant-menu-inline {
  background: #eee;
} */
.catalogDetail .ant-menu-inline .ant-menu-submenu-title {
  margin-bottom: 0px;
}

.catalogDetail .ant-menu-item-active {
  background: #f0cd48 !important;
  color: #333;
  margin: 0px;
}
.catalogDetail .ant-menu-item-selected {
  background: #f0cd48 !important;
  color: #333;
  margin: 0px;
}
</style>
<style lang="stylus" scoped>
.catalogDetail {
  display: flex;
  border-top: 1px solid #ccc;

  .Left {
    width: 400px;
    background: #eee;

    .title {
      width: 400px;
      height: 103px;
      background: #d2d5da;
      margin-bottom: 8px;

      .box {
        width: 400px;
        display: flex;

        .left {
          width: 142px;
          height: 82px;
          padding-top: 10px;
          padding-left: 12px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .right {
          padding-left: 10px;
          flex: 1;

          h2 {
            font-size: 16px;
            color: #333333;
            padding-top: 12px;
            margin-bottom: 11px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 230px;
          }

          p {
            color: #666666;
            font-size: 14px;
            margin-bottom: 0;
          }
        }
      }
    }

    .menu {
      width: 400px;
      margin: 0 auto;
      background: #eee;
      min-height: 600px;
      margin-bottom: 50px;

      .log {
        width: 388px;
        padding-left: 6px;
        background: #eee;
      }
    }
  }

  .Right {
    background: #fff;
    flex: 1;
  }
}
</style>
